"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _consts = require("../../Text/consts");
var _twClasses = require("../../Text/helpers/twClasses");
var _tailwind = require("../../common/tailwind");
const alternativeTextTypeColors = {
  [_consts.TYPE_OPTIONS.PRIMARY]: _twClasses.typeClasses.primary,
  [_consts.TYPE_OPTIONS.SECONDARY]: _twClasses.typeClasses.secondary,
  [_consts.TYPE_OPTIONS.INFO]: "text-blue-dark",
  [_consts.TYPE_OPTIONS.SUCCESS]: "text-green-dark",
  [_consts.TYPE_OPTIONS.WARNING]: "text-orange-dark",
  [_consts.TYPE_OPTIONS.CRITICAL]: "text-red-dark",
  [_consts.TYPE_OPTIONS.WHITE]: _twClasses.typeClasses.primary
};
const ItineraryText = ({
  type = _consts.TYPE_OPTIONS.PRIMARY,
  size = _consts.SIZE_OPTIONS.NORMAL,
  weight = _consts.WEIGHT_OPTIONS.NORMAL,
  align = _consts.ALIGN_OPTIONS.START,
  as: Component = _consts.ELEMENT_OPTIONS.P,
  uppercase,
  italic,
  strikeThrough,
  spaceAfter,
  children,
  withBackground
}) => {
  return /*#__PURE__*/_react.default.createElement(Component, {
    className: (0, _clsx.default)("orbit-text font-base m-0 text-wrap", alternativeTextTypeColors[type], withBackground && _twClasses.backgroundClasses[type], _twClasses.sizeClasses[size], _twClasses.weightClasses[weight], _tailwind.textAlignClasses[align], uppercase && "uppercase", strikeThrough && "line-through", italic && "italic", spaceAfter && _tailwind.spaceAfterClasses[spaceAfter])
  }, children);
};
var _default = exports.default = ItineraryText;